module.exports = __webpack_public_path__ + "static/media/idVerified.c359dabd.png";